﻿import { onLoad } from 'runtime';

onLoad(context => {
    context.querySelectorAll('.add-to-cart').forEach(element => {
        element.querySelector('form').addEventListener('success', () => {
            // Trigger the "cart:added" event.
            element.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { items: [{ id: element.$data.product.id, name: element.$data.product.name, categoryName: element.$data.productListing.categoryName, brandName: element.$data.product.brandName, taxRate: element.$data.product.taxRate, price: element.$data.product.price, quantity: element.$data.quantity }] } }));
        });
    });
});